import React from 'react';
import { makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0),
    padding: theme.spacing(2, 2.5),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: 12,
    backgroundColor: alpha(theme.palette.primary.main, 0.06),
    '& > p': {
      color: theme.palette.text.secondary,
      marginBottom: 0,
      lineHeight: 1.75
    }
  }
}));

function Blockquote(props) {
  const classes = useStyles();

  return (
    <blockquote
      className={classes.root}
      {...props}
    />
  );
}

export default Blockquote;
